import { Claim } from './Claim';

export class AuthUserDto {
	userId: number;
	login = '';
	userName = '';
	userRole = '';
	bearerToken = '';
	forceDiscount: boolean;
	discountLimit: number;
	contragentId: number;
	isAuthenticated = false;
	expiresInUtc: Date;
	claims: Claim[] = [];
}
